import type { SyntheticEvent } from 'react';
import type React from 'react';
export type TNotificationUid = string | number;
export enum ENotificationType {
  error = 'error',
  info = 'info',
  success = 'success',
}
export type TNotificationInit = {
  message: React.ReactNode;
  title?: string;
  type?: (typeof ENotificationType)[keyof typeof ENotificationType];
  uid?: TNotificationUid;
};
export type TNotificationEvent = {
  message: React.ReactNode;
  title: string;
  uid: TNotificationUid;
  type: (typeof ENotificationType)[keyof typeof ENotificationType];
  close(event: Event | SyntheticEvent<unknown, Event>): void;
};
export type TNotificationsContextType = {
  notifications: Map<TNotificationUid, TNotificationEvent>;
  clearNotifications(): void;
  closeNotification(uid: TNotificationUid): void;
  showNotification(notification: TNotificationInit): void;
};